import React from 'react';
import { useSelector } from 'react-redux';

import { FlexRow } from 'ui-components/components/flex';

import messages from './messages';
import style from './notes.module.less';
import { DemoTooltipStar } from '../../../../../demos/components/demo-tooltip-star/demo-tooltip-star';
import { useContainsDemoOrder } from '../../../../../demos/hooks/use-contains-demo-order';
import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import FulfillmentPlanNotes from '../../../../../fulfillment-plans/notes';
import Global from '../../../../../store/global-selectors';
import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import SectionTitle from '../../../tab-section/title';
import { OrderDetailsSectionId } from '../../order-details-expanded-section-provider';

import textStyle from 'ui-components/components/text/text.module.less';

export const Notes = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const isDemoOrder = useContainsDemoOrder([fulfillmentPlanId]);
  const noteCount = useSelector(
    (state) =>
      (
        Global.selectEntitiesFulfillmentPlanProperty(state, {
          fulfillmentPlanId,
          property: 'notes',
        }) || []
      ).length,
  );

  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      collapsedContentClassName={style['notes-section-content']}
      collapsedSectionContent={
        <FulfillmentPlanNotes
          className={style['od-canvas-fulfillment-plan-notes']}
          fulfillmentPlanId={fulfillmentPlanId}
          hideUnpinned
          labelClassName={textStyle.label}
        />
      }
      contentClassName={style['notes-section-content']}
      headerContent={
        <>
          <FlexRow>
            <SectionTitle messageDescriptor={messages.notesSectionTitle} />
            {isDemoOrder ? <DemoTooltipStar altText={messages.demoTooltipAltText} tooltipText={messages.demoTooltipText} /> : null}
          </FlexRow>
          {!!noteCount && <div className={style['note-count']}>{noteCount}</div>}
        </>
      }
      sectionContent={
        <FulfillmentPlanNotes
          className={style['od-canvas-fulfillment-plan-notes']}
          fulfillmentPlanId={fulfillmentPlanId}
          labelClassName={textStyle.label}
        />
      }
      sectionId={OrderDetailsSectionId.Notes}
    />
  );
};
